export var MatchingStrategy;
(function (MatchingStrategy) {
    MatchingStrategy["ALL"] = "ALL";
    MatchingStrategy["ANY"] = "ANY";
})(MatchingStrategy || (MatchingStrategy = {}));
export var MatchingOperator;
(function (MatchingOperator) {
    MatchingOperator["EQUALS"] = "equals";
    MatchingOperator["NOT_EQUALS"] = "notEquals";
    MatchingOperator["IS_EMPTY"] = "isEmpty";
    MatchingOperator["IS_NOT_EMPTY"] = "isNotEmpty";
    MatchingOperator["INCLUDES_ONE"] = "includesOne";
    MatchingOperator["EXCLUDES_ONE"] = "excludesOne";
    MatchingOperator["INCLUDES_ALL"] = "includesAll";
    MatchingOperator["EXCLUDES_ALL"] = "excludesAll";
})(MatchingOperator || (MatchingOperator = {}));
export var MatchingSystemType;
(function (MatchingSystemType) {
    MatchingSystemType["TAGS"] = "conversationTags";
    MatchingSystemType["QUEUE"] = "conversationQueue";
    MatchingSystemType["STATUS"] = "conversationStatus";
    MatchingSystemType["LANGUAGE"] = "conversationLanguage";
    MatchingSystemType["AGENT_HAS_REPLIED"] = "agentHasReplied";
    MatchingSystemType["USER_HAS_REPLIED"] = "userHasReplied";
    MatchingSystemType["AGENT_HAS_REPLIED_TRIGGER"] = "agentHasRepliedSinceTrigger";
    MatchingSystemType["USER_HAS_REPLIED_TRIGGER"] = "userHasRepliedSinceTrigger";
})(MatchingSystemType || (MatchingSystemType = {}));
export var VariableScope;
(function (VariableScope) {
    VariableScope["SYSTEM"] = "system";
    VariableScope["INPUT"] = "input";
    // FLOW = 'flow', // 'flow' will be added later - maybe
})(VariableScope || (VariableScope = {}));
export var TagOperation;
(function (TagOperation) {
    TagOperation["TAG"] = "tag";
    TagOperation["UNTAG"] = "untag";
})(TagOperation || (TagOperation = {}));
